import type { User } from "firebase/auth";
import { mountSkillsPanel, type SkillsPanelHandle } from "@/character/skills-page";
import type { CharacterProfile } from "@/character/storage";
import type { HomeEconomy } from "@/home/economy";
import { mountPetIdlePreview } from "@/pet/mount-pet-idle-preview";
import type { PetDefinition } from "@/pet/types";

export type MountPetSkillsPanelOptions = {
  user: User;
  profile: CharacterProfile;
  getPet: () => PetDefinition | null;
  getEconomy: () => HomeEconomy;
  onPetUpdated: (pet: PetDefinition) => void;
  onEconomyUpdated: (economy: HomeEconomy) => void;
};

export function mountPetSkillsPanel(
  host: HTMLElement,
  options: MountPetSkillsPanelOptions,
): SkillsPanelHandle | null {
  const pet = options.getPet();
  if (!pet) return null;
  return mountSkillsPanel(host, options.user, options.profile, {
    embedded: true,
    editorInRoot: true,
    panelLayout: "pet-detail",
    cardPool: "pet",
    getSkillBar: () => options.getPet()?.skillBar ?? pet.skillBar,
    getEconomy: options.getEconomy,
    getUsageDemoActor: () => {
      const p = options.getPet();
      if (!p?.spritesheetDataUrl) return null;
      return { spritesheetDataUrl: p.spritesheetDataUrl, grid: p.grid };
    },
    mountIdlePreview: (previewHost) => {
      const p = options.getPet();
      if (!p) return () => {};
      return mountPetIdlePreview(previewHost, p, { displaySizePx: 72 });
    },
    onSkillBarUpdated: (bar) => {
      const current = options.getPet();
      if (!current) return;
      options.onPetUpdated({ ...current, skillBar: bar });
    },
    onEconomyUpdated: options.onEconomyUpdated,
  });
}
